export default "__VITE_ASSET__f89c1898__"